import { TableRow, TableRowProps } from "@mui/material";
import {
    POSITIONS_TABLE_ROW_PADDING_Y,
    TABLE_ROW_FONT_SIZE,
    TABLE_ROW_PADDING_X
} from "../../shared/constants/table.constants";

export function TableFooterRow({
    sx,
    ...props
}: TableRowProps){
    return(
        <TableRow
            sx={{
                '&:last-child td, &:last-child th': {
                    border: 0
                },
                '& .MuiTableCell-root': {
                    textAlign: 'right',
                    fontWeight: 'bold',
                    paddingY: POSITIONS_TABLE_ROW_PADDING_Y,
                    paddingX: TABLE_ROW_PADDING_X,
                    fontSize: TABLE_ROW_FONT_SIZE,
                },
            }}
            {...props}
        />
    )
}